<template>
  <v-expand-transition>
    <ul
      v-show="visible"
      role="list"
      aria-live="polite"
      class="brand-password-requirements pa-0 ma-0 mt-2"
    >
      <li
        v-for="rule in rules"
        :key="rule.key"
        class="d-flex align-center text-caption mb-1"
        :class="rule.satisfied ? 'text-mint600' : 'text-orange400'"
      >
        <component
          :is="rule.satisfied ? PhCheckCircle : PhCircle"
          :weight="rule.satisfied ? 'fill' : 'regular'"
          class="mr-2"
          aria-hidden="true"
        />
        <span>{{ rule.label }}</span>
      </li>
    </ul>
  </v-expand-transition>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PhCheckCircle, PhCircle } from '@phosphor-icons/vue'
import { PASSWORD_MIN_LENGTH } from '@/utils/constants'

defineOptions({
  name: 'BrandPasswordRequirements',
})

const props = defineProps({
  password: {
    type: String,
    default: '',
  },
  visible: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()

const rules = computed(() => [
  {
    key: 'min_length',
    satisfied: (props.password?.length ?? 0) >= PASSWORD_MIN_LENGTH,
    label: t('form.password_requirements.min_length', { min: PASSWORD_MIN_LENGTH }),
  },
])
</script>

<style lang="scss" scoped>
.brand-password-requirements {
  list-style: none;
}
</style>
